/**
 * 自定义发布订阅模式，方便组件与页面进行交互。
 * 在能够百分之百确定页面或组件被渲染的情况下，才可以使用该模式。
 * 该事件需要手动调用remove函数进行解绑，避免出现问题
 */
 interface rule {
    [key: string]: any
  }
  class Events {
    private eventsList: rule = {}
    constructor() { }
  
    // 用于发布事件
    /**
     * @param type 事件名称，类型 
     * @param hander  执行的事件
     */
    public on(type: string, hander: Function): void {
      // 只有在不存在该事件的时候才添加
      if (!(type in this.eventsList)) {
        this.eventsList[type] = []
      }
      this.eventsList[type].push(hander)
    }
  
    /**
     * @param type  需要发送的事件
     * @param param 传递的参数 
     */
    public emit(type: string, ...param: any): void {
      // 事件不存在
      if (!(type in this.eventsList)) {
        new Error('事件不存在');
        return;
      }
  
      this.eventsList[type].forEach((handler: Function) => {
        handler && handler(...param)
      })
    }
    /**
     * 移除事件
     */
    public removeEvent(type: string, handler: Function): void {
      // 事件不存在
      if (!(type in this.eventsList)) {
        return;
      }
      // 回调函数不存在
      if (!handler) {
        delete this.eventsList[type]
        return;
      }
      let index = this.eventsList[type].findIndex((el: Function) => el === handler);
      if (!index) {
        return;
      }
      this.eventsList[type].splice(index, 1);
      if (this.eventsList[type].lenght === 0) {
        delete this.eventsList[type];
      }
    }
  }
  
  export default new Events();